import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=67cf3fe5"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67cf3fe5')) {
      api.createRecord('67cf3fe5', component.options)
    } else {
      api.reload('67cf3fe5', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=67cf3fe5", function () {
      api.rerender('67cf3fe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/dynamic_attribution/Register.vue"
export default component.exports